import React from "react";

const FILL = "#B5B5B5";

export const hasScreenshotLayoutIcon = (id: number): boolean => id === 26;

/** Corrected Screenshot icon for the top-right upload layout. */
const ScreenshotLayoutIcon = ({id}: {id: number}) => {
  if (!hasScreenshotLayoutIcon(id)) return null;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 90 50"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-screenshot-layout-icon={id}
    >
      <path
        fill={FILL}
        d="M53.4 18.39H43.07c-.46 0-.83.37-.83.83v6.5c0 .46.37.83.83.83H53.4c.46 0 .83-.37.83-.83v-6.5c0-.46-.37-.83-.83-.83Zm-7.18 6.84c0 .37-.27.66-.6.66h-1.89c-.33 0-.6-.3-.6-.66v-5.56c0-.37.27-.66.6-.66h1.89c.33 0 .6.3.6.66v5.56Zm6.66-6.14c.37 0 .66.25.66.55v1.75c0 .3-.3.55-.66.55h-5.56c-.37 0-.66-.25-.66-.55v-1.75c0-.3.3-.55.66-.55h5.56Zm.03 3.22c.37 0 .66.25.66.55v1.75c0 .3-.3.55-.66.55h-5.56c-.37 0-.66-.25-.66-.55v-1.75c0-.3.3-.55.66-.55h5.56Z"
      />
      <g data-screenshot-frame="" transform="translate(90 0) scale(-1 1)">
        <path
          fill={FILL}
          d="M76.22 44.07c2.8 0 5-2.2 5-5V0H0v44.07h76.22ZM34.91 18.87c0-.8.7-1.4 1.5-1.4h10.7c.8 0 1.5.6 1.5 1.4v7.2c0 .8-.7 1.4-1.5 1.4h-10.7c-.8 0-1.5-.6-1.5-1.4v-7.2Z"
        />
      </g>
    </svg>
  );
};

export default ScreenshotLayoutIcon;
